/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Igdbtimetobeat4Inputs */

const id_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Waktu untuk Menamatkan`)
};

const ms_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Masa untuk Menamatkan`)
};

const da_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Tid at gennemføre`)
};

const de_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Spielzeit`)
};

const en_us2_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Time To Beat`)
};

const es_es2_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Tiempo para completar`)
};

const es_mx2_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Tiempo para completar`)
};

const fil_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Time To Beat`)
};

const fr_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Durée de vie`)
};

const it_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Tempo per completare`)
};

const hu_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Teljesítési idő`)
};

const nl_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Speelduur`)
};

const no_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Spilletid`)
};

const pl_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Czas ukończenia`)
};

const pt_br2_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo para zerar no IGDB`)
};

const pt_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Tempo para completar`)
};

const ro_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Timp de finalizare`)
};

const fi_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Läpäisyaika`)
};

const sv_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Tid att slå`)
};

const vi_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Thời gian hoàn thành`)
};

const tr_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Bitirme Süresi`)
};

const cs_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Doba dohrání`)
};

const bg_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Време за завършване`)
};

const ru_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время прохождения согласно IGDB`)
};

const uk_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB Час проходження`)
};

const ar_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB وقت الإكمال`)
};

const hi_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB पूरा करने का समय`)
};

const th_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB เวลาในการเล่นจบ`)
};

const ja_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB クリア時間`)
};

const zh_cn2_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB通关时间`)
};

const zh_hant1_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB通關時間`)
};

const ko_offerdetail_overview_igdbtimetobeat4 = /** @type {(inputs: Offerdetail_Overview_Igdbtimetobeat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGDB 클리어 시간`)
};

/**
* | output |
* | --- |
* | "IGDB Time To Beat" |
*
* @param {Offerdetail_Overview_Igdbtimetobeat4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_igdbtimetobeat4 = /** @type {((inputs?: Offerdetail_Overview_Igdbtimetobeat4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Igdbtimetobeat4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "ms") return ms_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "da") return da_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "de") return de_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "fil") return fil_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "fr") return fr_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "it") return it_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "hu") return hu_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "nl") return nl_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "no") return no_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "pl") return pl_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "pt") return pt_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "ro") return ro_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "fi") return fi_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "sv") return sv_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "vi") return vi_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "tr") return tr_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "cs") return cs_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "bg") return bg_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "ru") return ru_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "uk") return uk_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "ar") return ar_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "hi") return hi_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "th") return th_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "ja") return ja_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_igdbtimetobeat4(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_igdbtimetobeat4(inputs)
	return ko_offerdetail_overview_igdbtimetobeat4(inputs)
});
export { offerdetail_overview_igdbtimetobeat4 as "offerDetail.overview.igdbTimeToBeat" }